import { connect } from 'react-redux';

import Message from './Message';
import { selectMessage, deleteMessageFail, retryMessageFail } from "../../actions/chatActions";

const mapStateToProps = state => ({
  identity: state.identity
});

const mapDispatchToProps = dispatch => ({
  selectMessage: (chatId, messageId, selectableType) => dispatch(selectMessage(chatId, messageId, selectableType)),
  retryMessageFail: message => dispatch(retryMessageFail(message)),
  deleteMessageFail: message => dispatch(deleteMessageFail(message))
});

export default connect(mapStateToProps, mapDispatchToProps)(Message);
